import { render, staticRenderFns } from "./TicketsRemoteAssistance.vue?vue&type=template&id=136f2c18&"
import script from "./TicketsRemoteAssistance.vue?vue&type=script&lang=ts&"
export * from "./TicketsRemoteAssistance.vue?vue&type=script&lang=ts&"
import style0 from "./TicketsRemoteAssistance.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VSnackbar } from 'vuetify/lib/components/VSnackbar';
import { VStepper } from 'vuetify/lib/components/VStepper';
import { VStepperContent } from 'vuetify/lib/components/VStepper';
import { VStepperStep } from 'vuetify/lib/components/VStepper';
installComponents(component, {VBtn,VContainer,VForm,VSnackbar,VStepper,VStepperContent,VStepperStep})


/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\javie\\Documents\\Javier\\Developer\\Landing Dayco\\dayco-cportal-app-client\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('136f2c18')) {
      api.createRecord('136f2c18', component.options)
    } else {
      api.reload('136f2c18', component.options)
    }
    module.hot.accept("./TicketsRemoteAssistance.vue?vue&type=template&id=136f2c18&", function () {
      api.rerender('136f2c18', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/tickets/tickets-form/TicketsRemoteAssistance.vue"
export default component.exports